import { defineMessages } from 'react-intl';

export default defineMessages({
  eveningTitle: {
    id: 'features.dailyActivity.eveningTitle',
    defaultMessage: 'Evening daily activity',
  },
  fromWorkout: {
    id: 'features.dailyActivity.fromWorkout',
    defaultMessage: '{value} from workouts',
  },
  logButton: {
    id: 'features.dailyActivity.logButton',
    defaultMessage: 'Log Daily Activity',
  },
  moreLabel: {
    id: 'features.dailyActivity.moreLabel',
    defaultMessage: 'More',
  },
  morningTitle: {
    id: 'features.dailyActivity.morningTitle',
    defaultMessage: 'Morning daily activity',
  },
  noChanges: {
    id: 'features.dailyActivity.noChanges',
    defaultMessage: 'Nothing to save — no fields were filled in.',
  },
  saveButton: {
    id: 'features.dailyActivity.saveButton',
    defaultMessage: 'Save',
  },
  saved: {
    id: 'features.dailyActivity.saved',
    defaultMessage: 'Saved.',
  },
  shareWithTrainer: {
    id: 'features.dailyActivity.shareWithTrainer',
    defaultMessage: 'Share with your trainer',
  },
});
